import Vue from "vue";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";
import Loader from "@/@core/components/Loader.vue";

Vue.component(FeatherIcon.name, FeatherIcon);
Vue.component(Loader.name, Loader);
